import { FETCH_GENRE } from "../actions/types";

export default (state = {}, action) => {
  switch (action.type) {
    case FETCH_GENRE:
      return action.payload.playlists;
    default:
      return state;
  }
};
